/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { type BodyOf, tasksV1CommentsDeleteDestroy } from '../fetch-client';
import { GetTask } from '../queries/get-task';
import { useFetchOpts } from '../use-fetch-opts';

export namespace DeleteTaskComment {
  export type Input = {
    id: string;
    taskId: string;
  };
  export type Output = void;

  function bodyFromInput({
    id,
  }: Input): BodyOf<typeof tasksV1CommentsDeleteDestroy> {
    return {
      uuid: id,
    };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();
    const queryClient = rq.useQueryClient();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        await ok(tasksV1CommentsDeleteDestroy(body, opts));
        return;
      },
      async onSuccess(_, input) {
        await queryClient.invalidateQueries({
          queryKey: GetTask.key({ id: input.taskId }),
        });
      },
    });
  }
}
